export default __webpack_public_path__ + "static/media/hinge8.bcd45b15.jpg";